module.exports = __webpack_public_path__ + "img/thumb-hm2.021f77a3.png";